import React, {useState, useEffect, useRef, useLayoutEffect} from 'react';
import {useDelayedTickContext} from "../../context/DelayedTickContext";
import {useStateUpdatePermission} from "../../../contexts/StateUpdateContext";
import {useQuoteContext} from "../../../contexts/QuoteContext";
import {formatIndianValue} from "@portfolio/utils/formatNumber";
import {useSharingContext} from "@dashboard/contexts/SharingContext";

const PriceDifferenceDisplay = ({
                                               instrumentToken,
                                               stock,
                                               priceColor,
                                               setPriceColor,
                                               setLastPriceColor,
                                               /*onPriceDifferenceChange,*/
                                               contextName,
                                               shouldUseStockForDisplay
                                           }) => {
    /*const [priceDifferencePercentage, setPriceDifferencePercentage] = useState(null);*/
    const priceDifferencePerctRef = useRef(null);
    const todaysGainAmountDifferenceRef = useRef(null);
    const {canUpdateState} = useStateUpdatePermission(); // Access the permission state
    const delayedTickContext = useDelayedTickContext();
    const quoteContext = useQuoteContext();
    const { showFormattedNumbers } = useSharingContext();

    const contextData = (() => {
        switch (contextName) {
            case 'DelayedTickContext':
                return delayedTickContext;
            case 'QuoteContext':
                return quoteContext;
            default:
                throw new Error(`Unknown context: ${contextName}`);
        }
    })();
    const delayedTick = contextData.delayedTick;

    useLayoutEffect(() => {
        if (canUpdateState) {
            priceDifferencePerctRef.current = stock.todayGainPercentage.toFixed(2);
            todaysGainAmountDifferenceRef.current = stock.todayGain.toFixed(2);

            if (stock.currentPrice > stock.closePrice) {
                setPriceColor('#33A533'); // Set green for upward trend
                setLastPriceColor('#33A533'); // Set green for last-traded-price
            } else if (stock.currentPrice < stock.closePrice) {
                setPriceColor('#FF6666'); // Set red for downward trend
                setLastPriceColor('#FF6666'); // Set red for last-traded-price
            } else {
                setPriceColor('#070707'); // Set red for downward trend
                setLastPriceColor('#070707'); // Set red for last-traded-price
            }
        }
    }, []);

    // Fetch and calculate price difference
    useEffect(() => {
        if (canUpdateState) {
            if (delayedTick.lastTradedPrice && delayedTick.closePrice) {
                const priceDifference = delayedTick.lastTradedPrice - delayedTick.closePrice;
                const percentageDifference = (priceDifference / delayedTick.closePrice) * 100;

                const newTodaysGainAmountDifference = (priceDifference * stock.netQuantity).toFixed(2);
                const newPercentageDifference = percentageDifference.toFixed(2);

                if (canUpdateState) {
                    if (priceDifferencePerctRef.current !== newPercentageDifference) {
                        priceDifferencePerctRef.current = newPercentageDifference;
                        /*onPriceDifferenceChange(percentageDifference);*/
                    }
                    if (todaysGainAmountDifferenceRef.current !== newTodaysGainAmountDifference) {
                        todaysGainAmountDifferenceRef.current = newTodaysGainAmountDifference;
                    }
                }

                // Determine color based on price difference

                if (delayedTick.lastTradedPrice > delayedTick.closePrice) {
                    setPriceColor('#33A533'); // Set green for upward trend
                    setLastPriceColor('#33A533'); // Set green for last-traded-price
                } else if (delayedTick.lastTradedPrice < delayedTick.closePrice) {
                    setPriceColor('#FF6666'); // Set red for downward trend
                    setLastPriceColor('#FF6666'); // Set red for last-traded-price
                } else {
                    setPriceColor('#070707'); // Set red for downward trend
                    setLastPriceColor('#070707'); // Set red for last-traded-price
                }
            }
        }
    }, [delayedTick.lastTradedPrice]);

    return (
        <div className="price-difference-pf" >
             <div className="overall-gain-percentage" style={{color: priceColor}}>
               {shouldUseStockForDisplay
                   ? <>
                       {stock.todayGainPercentage < 0 && <span className="negative">-</span>}
                       {Math.abs(stock.todayGainPercentage ?? 0).toFixed(2)}%
                   </>
                   : <>
                       {priceDifferencePerctRef.current < 0 && <span className="negative">-</span>}
                       {Math.abs(priceDifferencePerctRef.current ?? 0)}%
                   </>
               }
            </div>
            <span className="overall-gain-amount">
               {formatIndianValue(
                   shouldUseStockForDisplay
                       ? stock.todayGain
                       : todaysGainAmountDifferenceRef.current ?? stock.todayGain,
                   showFormattedNumbers
               )}
            </span>

        </div>
    );
};


export default PriceDifferenceDisplay;
